// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\ValueObject.tt
// </auto-generated>
// ------------------------------------------------------------------------------
/**
 * ARGB颜色 实体类
 * 采用ARGB编码的颜色
 */
export class ARGBColor {
  alpha: number;
  red: number;
  green: number;
  blue: number;

  constructor(alpha = 0, red = 0, green = 0, blue = 0) {
    this.alpha = alpha;
    this.red = red;
    this.green = green;
    this.blue = blue;
  }
}
